<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <!-- <div class="instruction">Please select a start and end date:</div> -->
        <div class="row expanded">
          <div class="small-12 column">
            <div class="date-input">
              <label>User:</label>
              <select v-model="selectedUser" :disabled="corpLoading">
                <option :value="goResID" >{{ `GO Reservations (${goResID})` }}</option>
                <option v-for="(x, i) in dbUsers" :value="x.id" :key="i">{{ `${x.name} (${x.id})` }}</option>
                <!-- <option :value="376128" v-show="env === 'production'">{{ `Koi Ride (376128)` }}</option>
                <option :value="262132" v-show="env === 'production'">{{ `Cares Act (262132)` }}</option>
                <option :value="262133" v-show="env === 'production'">{{ `Great Plates (262133)` }}</option>
                <option :value="281780" v-show="env === 'production'">{{ `Cares Act 2 (281780)` }}</option>
                <option :value="300034" v-show="env === 'production'">{{ `Micro Transit Jw Marriot Corporate (300034)` }}</option>
                <option :value="285033" v-show="env === 'production'">{{ `Beverly Hilton (285033)` }}</option>
                <option :value="266672" v-show="env === 'production'">{{ `District Attorney - Los Angeles (266672)` }}</option>
                <option :value="270861" v-show="env === 'production'">{{ `District Attorney San Bernardino (270861)` }}</option>
                <option :value="270870" v-show="env === 'production'">{{ `District Attorney Long Beach (270870)` }}</option>
                <option :value="270876" v-show="env === 'production'">{{ `District Attorney Pasadena-Alhambra (270876)` }}</option>
                <option :value="270878" v-show="env === 'production'">{{ `District Attorney Compton (270878)` }}</option>
                <option :value="270880" v-show="env === 'production'">{{ `District Attorney Inglewood (270880)` }}</option>
                <option :value="270881" v-show="env === 'production'">{{ `District Attorney Lancaster (270881)` }}</option>
                <option :value="270882" v-show="env === 'production'">{{ `District Attorney LAX (270882)` }}</option>
                <option :value="270883" v-show="env === 'production'">{{ `District Attorney LAX Branch (270883)` }}</option>
                <option :value="270884" v-show="env === 'production'">{{ `District Attorney Martinez (270884)` }}</option>
                <option :value="270886" v-show="env === 'production'">{{ `District Attorney Norwalk (270886)` }}</option>
                <option :value="270887" v-show="env === 'production'">{{ `District Attorney Pas.Juvenile (270887)` }}</option>
                <option :value="270888" v-show="env === 'production'">{{ `District Attorney Pomona (270888)` }}</option>
                <option :value="270890" v-show="env === 'production'">{{ `District Attorney San Fernando (270890)` }}</option>
                <option :value="270892" v-show="env === 'production'">{{ `District Attorney Torrance (270892)` }}</option>
                <option :value="270893" v-show="env === 'production'">{{ `District Attorney Van Nuys (270893)` }}</option>
                <option :value="278711" v-show="env === 'production'">{{ `District Attorney Witness Assistance (278711)` }}</option>
                <option :value="270894" v-show="env === 'production'">{{ `District Attorney WLA (270894)` }}</option>
                <option :value="270895" v-show="env === 'production'">{{ `District Attorney Malibu (270895)` }}</option>
                <option :value="275267" v-show="env === 'production'">{{ `University of Southern California (275267)` }}</option> -->
              </select>
            </div>
          </div>
        </div>
        <div class="row expanded">
          <div class="small-6 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
          <div class="small-6 column padding-L">
            <div class="date-input end-date">
              <label>End Date:</label>
              <datepicker class="datepicker" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <div class="form-group">
          <div class="download-type">
            <label :class="{'pdf':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="pdfChecked"
                @click="formatCheck" />
              PDF
            </label>
            <label :class="{'csv':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="csvChecked"
                @click="formatCheck" />
              CSV
            </label>
          </div>
          <!--
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.payout, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.payout" />
                <span>{{ reportLabel('payout') }}</span>
              </label>
            </div>
            <div :class="['small-12 column report', reportStatus.serviceTypeBrand, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.serviceTypeBrand" />
                <span>{{ reportLabel('serviceTypeBrand') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.serviceTypeBrand}"
                :disabled="!selectedReports.serviceTypeBrand" v-model="selectedServiceBrand">
                <option value="bookingTime">Booking Date</option>
                <option value="pickupTime">Pickup Date</option>
              </select>
            </div>
            <div :class="['small-12 column report', reportStatus.cancellationReport, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.cancellationReport" />
                <span>{{ reportLabel('cancellationReport') }}</span>
              </label>
              <select :class="{'disabled':!selectedReports.cancellationReport}"
                :disabled="!selectedReports.cancellationReport" v-model="selectedCancellationType">
                <option value="all">All</option>
                <option value="consumer">Canceled by Consumer</option>
                <option value="admin">Canceled by Any Admin</option>
                <option value="_admin">Canceled by Specific Admin</option>
              </select>
              <div class="admin-box" v-show="selectedCancellationType === '_admin'">
                <input type="text" v-model="searchAdmin" @focus="adminSearchFocus" @blur="adminSearchBlur"
                  :disabled="!selectedReports.cancellationReport"/>
                <ul v-show="showSearchAdminList">
                  <li v-for="admin in admins" :key="admin.id" @click="selectAdmin(admin)">{{ admin.name }}</li>
                </ul>
              </div>
            </div>
            <div :class="['small-12 column report', reportStatus.driverPaymentBonus, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.driverPaymentBonus" />
                <span>{{ reportLabel('driverPaymentBonus') }}</span>
              </label>
            </div>
          </div>
          -->
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="empty in error.empty">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a v-bind:class="{ 'button cta success small block': true, disabled: pdf.loading }"
          href="javascript:;" @click="startProcess">
          <i class="fa fa-spinner fa-spin" v-show="pdf.loading"></i>
          <span v-show="!pdf.loading">Generate and Download Report</span>
        </a>
      </div>

      <div id="pdf-view" :class="[pdf.class]">
        <div v-if="isDirectBill">
          <div v-for="(pageData, pageIndex) in pdf.table.data.completed" :class="['page', pageIndex]">
            <div class="title">Opoli Reports</div>
            <div class="title">{{ pdf.title }}</div>
            <div class="date-range">{{ pdf.date }}</div>
            <div class="date-range">Completed</div>
            <table>
              <thead>
                <tr>
                  <th v-for="label in pdf.table.label" v-html="label"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in pageData">
                  <td v-for="(value, i) in data" :class="[i]">{{ value }}</td>
                </tr>
                <!-- <tr v-if="currentPage(pageIndex) == totalPageCompleted" class="total">
                  <td colspan="4">Total ({{ pdf.table.total.totalCompleted }})</td>
                  <td class="fare">${{ pdf.table.total.fareCompleted }}</td>
                  <td colspan="2"></td>
                </tr> -->
              </tbody>
            </table>
            <div class="page-count">page {{ currentPage(pageIndex) }} of {{ parseInt(totalPageCompleted) + parseInt(totalPageNoShow) }}</div>
          </div>
          
          <div v-for="(pageDataNS, pageIndexNS) in pdf.table.data.noshow" :class="['page', `page${parseInt(currentPage(pageIndexNS)) + totalPageCompleted}`]">
            <div class="title">Opoli Reports</div>
            <div class="title">{{ pdf.title }}</div>
            <div class="date-range">{{ pdf.date }}</div>
            <div class="date-range">No Show</div>
            <table>
              <thead>
                <tr>
                  <th v-for="label in pdf.table.label" v-html="label"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in pageDataNS">
                  <td v-for="(value, i) in data" :class="[i]">{{ value }}</td>
                </tr>

                <!-- <tr v-if="currentPage(pageIndexNS) == totalPageNoShow" class="total">
                  <td colspan="4">Total ({{ pdf.table.total.totalNoShow }})</td>
                  <td class="fare">${{ pdf.table.total.fareNoShow }}</td>
                  <td colspan="2"></td>
                </tr> -->
              </tbody>
            </table>
            <div class="page-count">page {{ parseInt(currentPage(pageIndexNS)) + totalPageCompleted }} of {{ totalPageCompleted + totalPageNoShow }}</div>
          </div>
        </div>

        <div v-else-if="!isServiceTypeBrand" v-for="(pageData, pageIndex) in pdf.table.data"
          :class="['page', pageIndex]">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr>
                <th v-for="label in pdf.table.label" v-html="label"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in pageData">
                <td v-for="(value, i) in data" :class="[i]">{{ value }}</td>
              </tr>

              <tr v-if="isDirectBill && currentPage(pageIndex) == totalPage" class="total">
                <td colspan="4">Total ({{ pdf.table.total.record }})</td>
                <td class="fare">${{ pdf.table.total.fare }}</td>
                <td colspan="2"></td>
              </tr>

              <tr v-if="isPayout && currentPage(pageIndex) == totalPage" class="total">
                <td>Total ({{ pdf.table.total.record }})</td>
                <td class="driverCount">{{ pdf.table.total.drivers }}</td>
                <td class="rsvpCount">{{ pdf.table.total.rsvp }}</td>
                <td class="totalPax">{{ pdf.table.total.pax }}</td>
                <td class="avgPax">{{ pdf.table.total.avgPax }}</td>
                <td class="fare">${{ pdf.table.total.fare }}</td>
                <td class="travelInsurance">${{ pdf.table.total.travelInsurance }}</td>
                <td class="airportFee">${{ pdf.table.total.airportFee }}</td>
                <td class="totalFare">${{ pdf.table.total.fareSum }}</td>
                <td class="avgFare">{{ pdf.table.total.avgFare }}</td>
                <!-- <td class="avgFarePP">{{ pdf.table.total.avgFarePP }}</td> -->
                <!-- <td class="charged">${{ pdf.table.total.charged }}</td> -->
                <td class="payment">${{ pdf.table.total.payment }}</td>
                <td class="paymentPercent">{{ pdf.table.total.paymentPercent }}%</td>
                <td class="pickupFee">${{ pdf.table.total.pickupFee }}</td>
                <td class="tips">${{ pdf.table.total.tips }}</td>
                <td class="bonus">${{ pdf.table.total.bonus }}</td>
                <td class="cancelFee">${{ pdf.table.total.cancelFee }}</td>
                <td class="driverPayment">${{ pdf.table.total.extraFee }}</td>
                <td class="driverPercent">{{ pdf.table.total.percent }}%</td>
              </tr>

              <tr v-if="isDriverPaymentBonus && currentPage(pageIndex) == totalPage" class="total">
                <td>Total ({{ pdf.table.total.record }})</td>
                <td class="brand" colspan="3"></td>
                <td class="baseFare">${{ pdf.table.total.baseFare }}</td>
                <td class="driverPayment">${{ pdf.table.total.driverPayment }}</td>
                <td class="bonus">${{ pdf.table.total.bonus }}</td>
                <td class="avgBonus">{{ pdf.table.total.avgBonus }}%</td>
                <td class="totalDriverPayment">${{ pdf.table.total.totalDriverPayment }}</td>
                <td colspan="2"></td>
              </tr>

            </tbody>
          </table>
          <div class="page-count">page {{ currentPage(pageIndex) }} of {{ totalPage }}</div>
        </div>

        <div v-else>
          <div v-for="(data, pageIndex) in pdf.table.serviceTypeBrandData" :class="['page', pageIndex]">
            <div class="brand-box" v-for="(dat, brand) in pdf.table.serviceTypeBrandData[pageIndex]">
              <div class="title">{{brand}} {{ pdf.title }}</div>
              <div class="date-range">{{ pdf.date }}</div>
              <table>
                <thead>
                  <tr>
                    <th v-for="label in pdf.table.label" v-html="label"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tableData, index) in dat">
                    <td v-for="(value, i) in tableData" :class="[i]">{{ value }}</td>
                  </tr>

                  <tr class="total">
                    <td>Total</td>
                    <td class="rsvp">{{ pdf.table.total[brand].rsvp }}</td>
                    <td class="asap">{{ pdf.table.total[brand].asap }}</td>
                    <td class="web">{{ pdf.table.total[brand].web }}</td>
                    <td class="admin">{{ pdf.table.total[brand].admin }}</td>
                    <td class="app">{{ pdf.table.total[brand].app }}</td>
                    <td class="app">{{ pdf.table.total[brand].go }}</td>
                    <td class="paxSum">{{ pdf.table.total[brand].paxSum }}</td>
                    <td class="paxAvg">{{ pdf.table.total[brand].paxAvg }}</td>
                    <td class="fareSum">${{ pdf.table.total[brand].fareSum }}</td>
                    <td class="fareAvg">{{ pdf.table.total[brand].fareAvg }}</td>
                    <td class="farePP">{{ pdf.table.total[brand].farePP }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'specialize-report',
  components: { datepicker },
  data () {
    return {
      env: CONFIG.Env,
      goResID: CONFIG.goResUserId,
      selectedUser: CONFIG.goResUserId,
      dbUsers: [
        // {id: 3597, name: 'Flip Flip'},
        // {id: 219990, name: 'GO Reservations'},
        // {id: 376128, name: 'Koi Ride'},
        // {id: 262132, name: 'Cares Act'},
        // {id: 262133, name: 'Great Plates'},
        // {id: 281780, name: 'Cares Act 2'},
        // {id: 300034, name: 'Micro Transit Jw Marriot Corporate'},
        // {id: 285033, name: 'Beverly Hilton'},
        // {id: 266672, name: 'District Attorney - Los Angeles'},
        // {id: 270861, name: 'District Attorney San Bernardino'},
        // {id: 270870, name: 'District Attorney Long Beach'},
        // {id: 270876, name: 'District Attorney Pasadena-Alhambra'},
        // {id: 270878, name: 'District Attorney Compton'},
        // {id: 270880, name: 'District Attorney Inglewood'},
        // {id: 270881, name: 'District Attorney Lancaster'},
        // {id: 270882, name: 'District Attorney LAX'},
        // {id: 270883, name: 'District Attorney LAX Branch'},
        // {id: 270884, name: 'District Attorney Martinez'},
        // {id: 270886, name: 'District Attorney Norwalk'},
        // {id: 270887, name: 'District Attorney Pas.Juvenile'},
        // {id: 270888, name: 'District Attorney Pomona'},
        // {id: 270890, name: 'District Attorney San Fernando'},
        // {id: 270892, name: 'District Attorney Torrance'},
        // {id: 270893, name: 'District Attorney Van Nuys'},
        // {id: 278711, name: 'District Attorney Witness Assistance'},
        // {id: 270894, name: 'District Attorney WLA'},
        // {id: 270895, name: 'District Attorney Malibu'},
        // {id: 275267, name: 'University of Southern California'}
      ],
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        directBill: true
        // payout: false,
        // serviceTypeBrand: false,
        // cancellationReport: false,
        // driverPaymentBonus: false
      },
      reportStatus: {
        directBill: ''
        // payout: '',
        // serviceTypeBrand: '',
        // cancellationReport: '',
        // driverPaymentBonus: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['directBill', 'payout', 'serviceTypeBrand', 'cancellationReport', 'driverPaymentBonus'],
      pdfChecked: true,
      csvChecked: false,
      selectedServiceBrand: 'bookingTime',
      selectedCancellationType: 'all',
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      searchAdmin: '',
      searchAdminId: '',
      searchAdminDelay: '',
      showSearchAdminList: false,
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      corpLoading: false
    }
  },
  computed: {
    show () { return this.$store.state.reports.rsvpReport.show },
    highlightedDates () {
      let self = this
      let result = { to: null, from: null }

      if (self.from !== null) { result.from = self.from }
      if (self.to !== null) { result.to = self.to }
      return result
    },
    totalPage () { return Object.keys(this.pdf.table.data).length },
    totalPageCompleted () { return Object.keys(this.pdf.table.data.completed).length },
    totalPageNoShow () { return Object.keys(this.pdf.table.data.noshow).length },
    isDirectBill () { return this.pdf.code === 'directBill' && this.totalPage },
    isPayout () { return this.pdf.code === 'payout' && this.totalPage },
    isServiceTypeBrand () { return this.pdf.code === 'serviceTypeBrand' && this.totalPage },
    admins () { return this.$store.state.reservationNotes.admins.filter(x => x.name.toLowerCase().includes(this.searchAdmin.toLowerCase())) },
    isDriverPaymentBonus () { return this.pdf.code === 'driverPaymentBonus' && this.totalPage }
  },
  methods: {
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the Start and End dates.'
        return false
      }

      let from = moment(self.from)
      let to = moment(self.to)

      if (from.isAfter(to)) {
        self.error.show = true
        self.error.message = 'End date must be after Start date.'
        return false
      }

      self.formatError = false
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true
        self.error.message = 'Please select which file format.'
        self.formatError = true
        return false
      }

      if (!self.selectedReports.directBill && !self.selectedReports.payout && !self.selectedReports.serviceTypeBrand
        && !self.selectedReports.cancellationReport && !self.selectedReports.driverPaymentBonus
      ) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }

      if (self.selectedReports.cancellationReport && self.pdfChecked) {
        self.error.show = true
        self.error.message = 'Only CSV format is allowed for Cancellation Report.'
        return false
      }

      if (self.selectedReports.cancellationReport && self.selectedCancellationType === '_admin' &&
        !self.searchAdminId
      ) {
        self.error.show = true
        self.error.message = 'Please select an admin.'
        return false
      }

      return true;
    },
    getNewDoc () {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      doc.setFont('helvetica')
      return doc
    },
    startProcess () {
      if (!this.isValid()) { return }

      this.pdf.list = []
      this.csv.list = []
      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.pdf.list.push(report)
          this.csv.list.push(report)
        }
      }

      this.pdf.loading = true
      this.generateReport()
    },
    generateReport (isCsv = false) {
      if (((!this.pdf.list.length && this.pdfChecked) || !this.pdfChecked) &&
        ((!this.csv.list.length && this.csvChecked) || !this.csvChecked)
      ) {
        this.pdf.loading = false
        return
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0])
        this.getDataReports(this.csv.list[0])
      } else {
        console.log('Processing:', this.pdf.list[0])
        this.getDataReports(this.pdf.list[0])
      }
    },
    getDataReports (type) {
      let self = this
      self.reportStatus[type] = 'loading'
      let orientationMax = self.orientation
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 22 : 35
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, r => {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error'
          return
        }

        self.setPdfLabel(type)
        self.pdf.table.data = {}
        self.pdf.table.extra = {}
        self.pdf.table.total = {}
        self.csv.data = []
        self.csv.total = {}

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list)
        } else {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.pdf.list.shift()
          self.csv.list.shift()
          self.generateReport()
        }
      })
    },
    apiParams (type) {
      let url = ''
      let start = moment(this.from)
      let end = moment(this.to)
      let data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      }

      switch (type) {
        case 'directBill':
          url = '/reports/directbill'
          data.consumerId = this.selectedUser
          break
        case 'payout':
          url = '/reports/payout'
          break
        case 'serviceTypeBrand':
          url = '/reports/services/branded'
          data.filter = this.selectedServiceBrand
          break
        case 'cancellationReport':
          url = '/reports/rsvp/canceled'
          data.cancelSource = this.selectedCancellationType
          if (this.selectedCancellationType === '_admin') {
            data.cancelSource = 'admin'
            data.adminId = this.searchAdminId
          }
          break
        case 'driverPaymentBonus':
          url = '/reports/rsvp/bonus'
          break
      }
      return { url: url, data: data }
    },
    setPdfLabel (type) {
      let start = moment(this.from)
      let end = moment(this.to)
      let dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY')

      this.pdf.code = type
      if (type === 'directBill') {
        this.pdf.class = 'report-direct-bill'
        let user = this.dbUsers.find(x => x.id === this.selectedUser)
        let uname = user ? user.name : ''
        if (this.selectedUser == 219990) uname = 'Go Reservations'
        this.pdf.title = `${uname} - Direct Bill`
        this.pdf.date = dateRange
        this.pdf.table.label = [
          'ID', 'Status', 'Pickup Time', 'Completed Time',
          'Fare', 'Source', 'Consumer Notes'
        ]
        this.pdf.table.labelCsv = []
        this.pdf.table.labelCsv = [
          'ID', 'Status', 'Pickup Time', 'Completed Time',
          'Fare', 'Source', 'Guest Name', 'Guest Mobile', 'Consumer Notes'
        ]
      }

      if (type === 'payout') {
        this.pdf.class = 'report-payout'
        this.pdf.title = 'Opoli Reports - Payout'
        this.pdf.date = 'Driver Payouts and Fees for ' + dateRange
        let riderFeeLabel = this.$settings.get('TravelInsuranceLabel') || 'Rider Fee'
        riderFeeLabel = riderFeeLabel.replace(' ', ' <br/>')
        this.pdf.table.label = [
          'Company', 'Driver <br/>Count', 'RSVP <br/>Count', 'Total <br/>PAX',
          'Avg <br/>PAX', 'Fare', riderFeeLabel, 'Airport <br/>Fee', 'Total <br/>Fare', 'Avg <br/>Fare',
          // 'Average <br/>Fare PP', 'Charged',
          'Driver <br/>Payment', 'Payment %', 'Pickup <br/>Fee', 'Tips', 'Bonus', 'Cancel <br/>Fee',
          'Total <br/>Payout', 'Payout %'
        ]
      }

      if (type === 'serviceTypeBrand') {
        this.pdf.class = 'service-brand'
        this.pdf.title = 'Reservations By Service Type'
        // this.pdf.date = 'By Booking Date (' + dateRange + ')'
        this.pdf.table.label = [
          'Service Type', 'RSVP <br/>Count', 'ASAP', 'Web <br/>Bookings', 'Admin',
          'Consumer <br/>App', 'Go Res', 'Total <br/>PAX', 'Avg <br/>PAX',
          'Total Fare', 'Avg <br/>Fare', 'Avg <br/>Fare PP'
        ]

        switch (this.selectedServiceBrand) {
          case 'bookingTime':
          this.pdf.date = 'By Booking Date (' + dateRange + ')'
          break
          case 'completeTime':
          this.pdf.date = 'By Completion Date (' + dateRange + ')'
          break
          case 'cancelTime':
          this.pdf.date = 'By Cancellation Date (' + dateRange + ')'
          break
          case 'pickupTime':
          this.pdf.date = 'Scheduled Pickup Dates (' + dateRange + ')'
          break
        }
      }

      if (type === 'cancellationReport') {
        this.pdf.class = 'cancellation-rsvp'
        this.pdf.title = 'Cancelled Reservations'
        this.pdf.table.label = [
          'RSVP ID', 'Brand', 'Customer <br/>Name', 'Service', 'Fare', 'Cancelled <br/>Date',
          'Cancelled <br/>By', 'Reason', 'Comments'
        ]
      }

      if (type === 'driverPaymentBonus') {
        this.pdf.class = 'driver-payment-bonus'
        this.pdf.title = 'Variance Report for Driver Payment'
        this.pdf.table.label = [
          'RSVP ID', 'Brand', 'Service', 'Driver Name', 'Base <br/>Fare', 'Driver <br/>Payment',
          'Variance <br/>Credit', 'Variance <br/>Credit %', 'Total Driver <br/>Payment',
          'Updated <br/>By', 'Updated <br/>On'
        ]
      }

    },
    buildPdfData (type, pdfData) {
      let self = this
      let groupCount = 0
      let page = 1

      // directBill
      let totalFareCompleted = 0
      let totalFareNoShow = 0
      let totalCompleted = 0
      let totalNoShow = 0
      let pageCompleted = 1
      let pageNoShow = 1

      // payout
      let totalDrivers = 0
      let totalRsvp = 0
      let totalPickupFee = 0
      let totalTips = 0
      let totalBonus = 0
      let totalCancelFee = 0
      let totalPax = 0
      let totalAvgPax = 0
      let totalFare = 0
      let totalFareSum = 0
      let totalAvgFare = 0
      let totalTravelInsurance = 0
      let totalAirportFee = 0
      let totalPayment = 0
      let totalBidAmount = 0
      let totalPaymentPercentage = 0
      let totalAvgFarePP = 0
      let totalDriverPayment = 0
      let totalDriverPercentage = 0

      // serviceTypeBrand
      let totalGo = 0
      let serviceTypeBrand = {
        total: {},
        data: {}
      }

      // driverPaymentBonus
      let totalAvgBonus = 0
      let totalDriverPaymentComputed = 0

      if (type === 'directBill') {
        pdfData.forEach(function (data, index) {
          if (!self.pdf.table.data.completed) {
            self.pdf.table.data.completed = {}
          }
          if (!self.pdf.table.data.noshow) {
            self.pdf.table.data.noshow = {}
          }
          if (!self.pdf.table.data.completed['page' + pageCompleted]) {
            self.pdf.table.data.completed['page' + pageCompleted] = []
          }
          if (!self.pdf.table.data.noshow['page' + pageNoShow]) {
            self.pdf.table.data.noshow['page' + pageNoShow] = []
          }

          if (['CHARGE', 'NOSHOW'].indexOf(data.reservationState) === -1) {
            return
          }

          let status = data.reservationState === 'CHARGE' ? 'completed' : 'noshow'
          let tempPage = data.reservationState === 'CHARGE' ? pageCompleted : pageNoShow
          self.pdf.table.data[status][`page${tempPage}`].push(self.buildTableData(type, data))

          if (self.csvChecked) {
            self.csv.data.push(self.buildCsvDataDirectBill(data))
          }

          if (data.reservationState === 'CHARGE') {
            totalFareCompleted += data.fareAmount
            totalCompleted++
          } else {            
            totalFareNoShow += data.fareAmount
            totalNoShow++
          }

          if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) {
            if (data.reservationState === 'CHARGE') {
              pageCompleted++
            } else {
              pageNoShow++
            }
          }
        })
      } else {
        pdfData.forEach(function (data, index) {
          if (!self.pdf.table.data['page' + page]) {
            self.pdf.table.data['page' + page] = []
          }

          if (type !== 'serviceTypeBrand') {
            self.pdf.table.data['page' + page].push(self.buildTableData(type, data))
          }
          if (self.csvChecked) {
            if (type === 'directBill') {
              self.csv.data.push(self.buildCsvDataDirectBill(data))
            } else {
              self.csv.data.push(self.buildCsvData(type, data))
            }
          }
          groupCount++

          if (type === 'payout') {
            totalDrivers += data.drivers
            totalRsvp += data.rsvp
            totalPax += data.paxSum
            totalAvgPax += parseFloat(data.paxAvg)
            totalFare += data.bidAmount
            totalTravelInsurance += parseFloat(data.travelInsurance || 0)
            totalAirportFee += parseFloat(data.airportFee || 0)
            totalFareSum += data.fareSum
            totalAvgFare += parseFloat(data.fareAvg)
            totalDriverPayment += parseFloat((data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee)
            totalPayment += data.payment
            totalBidAmount += data.bidAmount
            totalPickupFee += data.pickupFee
            totalTips += data.tips
            totalBonus += data.bonus
            totalCancelFee += data.cancelFee
            totalPaymentPercentage += parseFloat(data.paymentPercent || 0)
            totalDriverPercentage += parseFloat(data.percent)
          }

          if (type === 'serviceTypeBrand') {
            data.services.forEach(function (dat) {
              if (!serviceTypeBrand.data[data.name]) { serviceTypeBrand.data[data.name] = {} }
              let brandCode = ''
              let name = brandCode + dat.name
              serviceTypeBrand.data[data.name][name] = {
                name: name,
                rsvp: self.covertNumber(parseFloat(dat.rsvp)),
                asap: self.covertNumber(parseFloat(dat.asap)),
                web: self.covertNumber(parseFloat(dat.web)),
                admin: self.covertNumber(parseFloat(dat.admin)),
                app: self.covertNumber(parseFloat(dat.app)),
                go: self.covertNumber(parseFloat(dat.go)),
                paxSum: self.covertNumber(parseFloat(dat.paxSum)),
                paxAvg: self.covertNumber(parseFloat(dat.paxAvg).toFixed(2)),
                fareSum: self.covertNumber(parseFloat(dat.fareSum).toFixed(2)),
                fareAvg: self.covertNumber(parseFloat(dat.fareAvg).toFixed(2)),
                farePP: self.covertNumber(parseFloat(dat.farePP).toFixed(2))
              }

              if (!serviceTypeBrand.total[data.name]) {
                serviceTypeBrand.total[data.name] = {
                  rsvp: 0, asap: 0, web: 0, admin: 0, app: 0, go: 0,
                  paxSum: 0, paxAvg: 0, fareSum: 0, fareAvg: 0, farePP: 0,
                }
              }
              serviceTypeBrand.total[data.name].rsvp += dat.rsvp
              serviceTypeBrand.total[data.name].asap += dat.asap
              serviceTypeBrand.total[data.name].web += dat.web
              serviceTypeBrand.total[data.name].admin += dat.admin
              serviceTypeBrand.total[data.name].app += dat.app
              serviceTypeBrand.total[data.name].go += dat.go
              serviceTypeBrand.total[data.name].paxSum += dat.paxSum
              serviceTypeBrand.total[data.name].paxAvg += parseFloat(dat.paxAvg)
              serviceTypeBrand.total[data.name].fareSum += parseFloat(dat.fareSum)
              serviceTypeBrand.total[data.name].fareAvg += parseFloat(dat.fareAvg)
              serviceTypeBrand.total[data.name].farePP += parseFloat(dat.farePP)
            })

            let compPaxAvg = serviceTypeBrand.total[data.name].paxSum / serviceTypeBrand.total[data.name].rsvp
            let compFareAvg = serviceTypeBrand.total[data.name].fareSum / serviceTypeBrand.total[data.name].rsvp
            let compFarePPAvg = serviceTypeBrand.total[data.name].fareSum / serviceTypeBrand.total[data.name].paxSum

            serviceTypeBrand.total[data.name].paxAvg = self.covertNumber(compPaxAvg.toFixed(2))
            serviceTypeBrand.total[data.name].fareSum = self.covertNumber(parseFloat(serviceTypeBrand.total[data.name].fareSum).toFixed(2))
            serviceTypeBrand.total[data.name].fareAvg = self.covertNumber(compFareAvg.toFixed(2))
            serviceTypeBrand.total[data.name].farePP = self.covertNumber(compFarePPAvg.toFixed(2))
          }

          if (type === 'cancellationReport') {
            totalFare += parseFloat(data.fare)
          }

          if (type === 'driverPaymentBonus') {
            totalRsvp++
            totalFare += parseFloat(data.baseFare)
            totalDriverPayment += parseFloat(data.driverPayment)
            totalBonus += parseFloat(data.bonusAmount)
            // totalAvgBonus += parseFloat(data.bonusAmount / data.baseFare)
            totalDriverPaymentComputed += parseFloat(data.driverPayment + data.bonusAmount)
          }

          if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) { page++ }
        })
      }

      self.pdf.table.total.record = pdfData.length
      if (type === 'directBill') {
        self.pdf.table.total.totalCompleted = totalCompleted
        self.pdf.table.total.totalNoShow = totalNoShow
        self.pdf.table.total.fareCompleted = self.covertNumber(totalFareCompleted.toFixed(2))
        self.pdf.table.total.fareNoShow = self.covertNumber(totalFareNoShow.toFixed(2))
      }
      if (type === 'payout') {
        self.pdf.table.total.drivers = self.covertNumber(totalDrivers)
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        // self.pdf.table.total.charged = self.covertNumber(totalCharged.toFixed(2))
        self.pdf.table.total.pickupFee = self.covertNumber(totalPickupFee.toFixed(2))
        self.pdf.table.total.tips = self.covertNumber(totalTips.toFixed(2))
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2))
        self.pdf.table.total.cancelFee = self.covertNumber(totalCancelFee.toFixed(2))
        self.pdf.table.total.pax = self.covertNumber(totalPax)
        self.pdf.table.total.avgPax = self.covertNumber((totalPax / totalRsvp).toFixed(2))
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
        self.pdf.table.total.travelInsurance = self.covertNumber(totalTravelInsurance.toFixed(2))
        self.pdf.table.total.airportFee = self.covertNumber(totalAirportFee.toFixed(2))
        self.pdf.table.total.fareSum = self.covertNumber(totalFareSum.toFixed(2))
        self.pdf.table.total.avgFare = self.covertNumber((totalFareSum / totalRsvp).toFixed(2))
        self.pdf.table.total.payment = self.covertNumber(totalPayment.toFixed(2))
        let paymentPercent = (totalPayment / totalFareSum) * 100
        self.pdf.table.total.paymentPercent = self.covertNumber(paymentPercent.toFixed(2))
        // self.pdf.table.total.avgFarePP = self.covertNumber(totalAvgFarePP.toFixed(2))

        let averagePercentage = totalDriverPercentage / pdfData.length
        self.pdf.table.total.extraFee = self.covertNumber(totalDriverPayment.toFixed(2))
        self.pdf.table.total.percent = self.covertNumber(((totalDriverPayment / totalFareSum) * 100).toFixed(2))
      }
      if (type === 'serviceTypeBrand') {
        self.pdf.table.total = serviceTypeBrand.total

        // let counter = 0
        self.pdf.table.serviceTypeBrandData = {}
        for (let data in serviceTypeBrand.data) {
          if (!self.pdf.table.serviceTypeBrandData['page' + page]) { self.pdf.table.serviceTypeBrandData['page' + page] = {} }
          self.pdf.table.serviceTypeBrandData['page' + page][data] = serviceTypeBrand.data[data]
          // counter++

          // if (counter % 2 === 0) {
          //   counter = 0
          // }
          page++
        }
        page = Object.keys(self.pdf.table.serviceTypeBrandData).length
      }
      if (type === 'cancellationReport') {
        self.pdf.table.total.fare = self.covertNumber(totalFare.toFixed(2))
      }
      if (type === 'driverPaymentBonus') {
        self.pdf.table.total.baseFare = self.covertNumber(totalFare.toFixed(2))
        self.pdf.table.total.driverPayment = self.covertNumber(totalDriverPayment.toFixed(2))
        self.pdf.table.total.bonus = self.covertNumber(totalBonus.toFixed(2))
        totalAvgBonus = (totalBonus / totalFare) * 100
        self.pdf.table.total.avgBonus = self.covertNumber((totalAvgBonus).toFixed(2))
        self.pdf.table.total.totalDriverPayment = self.covertNumber((totalDriverPaymentComputed).toFixed(2))
      }

      if (self.pdfChecked) {
        if (type === 'directBill') {
          page = pageCompleted + pageNoShow
        }
        self.processDownloads('pdf', {type: type, page: page})
      } else {
        self.processDownloads('csv', {type: type})
      }
    },
    buildTableData (type, data) {
      let self = this
      if (type === 'directBill') {
        return {
          id: data.ID,
          status: data.reservationState === 'NOSHOW' ? data.reservationState : 'COMPLETED',
          pickupTime: moment(data.pickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
          completedTime: moment(data.completedTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm'),
          fare: self.covertNumber(parseFloat(data.fareAmount || 0).toFixed(2)),
          source: data.deviceType === 'ww' ? 'web' : data.deviceType,
          consumerNotes: data.consumerNotes || ''
        }
      }
      if (type === 'payout') {
        let driverPayment = (data.payment + data.bonus + data.pickupFee + data.tips) - data.cancelFee
        return {
          company: data.name,
          driverCount: self.covertNumber(data.drivers),
          rsvpCount: self.covertNumber(data.rsvp),
          totalPax: self.covertNumber(data.paxSum),
          avgPax: self.covertNumber(parseFloat(data.paxAvg).toFixed(2)),
          fare: self.covertNumber(parseFloat(data.bidAmount).toFixed(2)),
          travelInsurance: self.covertNumber(parseFloat(data.travelInsurance || 0).toFixed(2)),
          airportFee: self.covertNumber(parseFloat(data.airportFee || 0).toFixed(2)),
          totalFare: self.covertNumber(parseFloat(data.fareSum).toFixed(2)),
          avgFare: self.covertNumber(parseFloat(data.fareAvg).toFixed(2)),
          // avgFarePP: self.covertNumber(parseFloat(data.farePP).toFixed(2)),
          // charged: self.covertNumber(parseFloat(data.charged).toFixed(2)),
          payment: self.covertNumber(parseFloat(data.payment).toFixed(2)),
          paymentPercent: self.covertNumber(parseFloat(data.paymentPercent || 0).toFixed(2)),
          pickupFee: self.covertNumber(parseFloat(data.pickupFee).toFixed(2)),
          tips: self.covertNumber(parseFloat(data.tips).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonus).toFixed(2)),
          cancelFee: self.covertNumber(parseFloat(data.cancelFee).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(driverPayment).toFixed(2)),
          driverPercent: self.covertNumber(parseFloat(data.percent).toFixed(2))
        }
      }
      if (type === 'cancellationReport') {
        let index = CONFIG.brands.findIndex(x => x.id === data.brandId)
        let cancelBy = 'SYSTEM'
        let comments = data.comments
        if (data.cancelAdminId) {
          cancelBy = self.admins.filter(x => x.id === data.cancelAdminId)[0].name
        } else if (data.cancelFrom) {
          if (data.cancelFrom === 'consumer') {
            cancelBy = 'SELF'
          } else if (data.cancelFrom === 'provider') {
            cancelBy = 'DRIVER'
          }
        }
        if (data.isAsap === 1 && (data.cancelAdminId || data.cancelFrom === 'provider')) {
          comments = 'asap release'
        }
        if (self.selectedCancellationType === 'consumer') {
          cancelBy = 'SELF'
        }

        if (comments) {
          comments = comments.replace(/<[^>]*>/g, '')
        }

        return {
          rsvpId: data.ID,
          brand: index === -1 ? 'ERROR' : CONFIG.brands[index].code.toUpperCase(),
          customerName: data.name,
          service: data.serviceTypeLabel,
          fare: self.covertNumber(parseFloat(data.fare).toFixed(2)),
          cancelledDate: moment(data.cancelTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)),
          cancelledBy: cancelBy,
          reason: data.paxReason !== null ? data.paxReason : '',
          comments: comments
        }
      }
      if (type === 'driverPaymentBonus') {
        let index = CONFIG.brands.findIndex(x => x.id === data.brandId)
        let updatedBy = 'SYSTEM'
        if (data.bonusAdmin) {
          updatedBy = self.admins.filter(x => x.id === data.bonusAdmin)[0].name
        }

        return {
          rsvpId: data.ID,
          brand: index === -1 ? 'ERROR' : CONFIG.brands[index].code.toUpperCase(),
          service: data.serviceTypeLabel,
          driverName: data.driverName,
          baseFare: self.covertNumber(parseFloat(data.baseFare).toFixed(2)),
          driverPayment: self.covertNumber(parseFloat(data.driverPayment).toFixed(2)),
          bonus: self.covertNumber(parseFloat(data.bonusAmount).toFixed(2)),
          avgBonus: self.covertNumber(parseFloat((data.bonusAmount / data.baseFare) * 100).toFixed(2)),
          totalDriverPayment: self.covertNumber(parseFloat(data.bonusAmount + data.driverPayment).toFixed(2)),
          updatedBy: updatedBy,
          updatedOn: moment(data.bonusTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
        }
      }
    },
    fileName (type, format) {
      let timestamp = moment(this.from).format('YYYYMMDD') + '_' + moment(this.to).format('YYYYMMDD')
      switch (type) {
        case 'directBill': return 'reportsdirectbill_' + timestamp + '.' + format
        case 'payout': return 'reportspayout_' + timestamp + '.' + format
        case 'serviceTypeBrand': return 'servicetypebrand_' + timestamp + '.' + format
        case 'cancellationReport': return 'cancelledreport_' + timestamp + '.' + format
        case 'driverPaymentBonus': return 'variance_driverpaymentbonus_' + timestamp + '.' + format
      }
    },
    currentPage (page) { return page.substring(4) },
    processPdf (type, page) {
      let self = this
      let start = moment(self.from)
      let end = moment(self.to)
      let pageAsyncs  = []
      let landscapeReports = self.orientation
      let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let pdf = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      setTimeout(() => {
        for (let i = 0; i < page; i++) {
          // self.pdf.current = 'page' + (i + 1)
          pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/png', 1.0)
            pdf.addImage(imgData, 'PNG', 0, 0)
            if (i + 1 !== page) { pdf.addPage() }
          }).catch(e => {
            self.reportStatus[type] = 'has-error'
            self.pdf.list.shift()
            document.body.style.overflow = 'auto'
            self.processDownloads('csv', {type: type})
            console.warn(e)
          }))
        }

        Promise.all(pageAsyncs).then(() => {
          let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
          pdf.save(self.fileName(type, 'pdf'))
          self.reportStatus[type] = 'success'
          self.pdf.list.shift()
          document.body.style.overflow = 'auto'
          self.processDownloads('csv', {type: type})
        })
      }, 500)
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    resetSelectedStatus () {
      this.selectedReports = {
        directBill: true,
        payout: false,
        serviceTypeBrand: false,
        cancellationReport: false,
        driverPaymentBonus: false
      }
    },
    resetReportStatus () {
      this.error.show = false
      this.error.empty = []
      this.reportStatus = {
        directBill: '',
        payout: '',
        serviceTypeBrand: '',
        cancellationReport: '',
        driverPaymentBonus: ''
      }
    },
    reportLabel (type) {
      switch (type) {
        case 'directBill': return 'Direct Bill Report'
        case 'payout': return 'Payout Report'
        case 'serviceTypeBrand': return 'Reservation by Service Type (Per Brand)'
        case 'cancellationReport': return 'Cancellation Report'
        case 'driverPaymentBonus': return 'Variance Report for Driver Payment'
      }
    },
    buildCsvData (type, data) {
      let column = []
      this.pdf.table.label.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      this.csv.label = column

      let csvData = {}
      let pdfData = this.buildTableData(type, data)

      let i = 0
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key]
        i++
      }
      return csvData
    },
    buildCsvDataDirectBill (data) {
      let column = []
      this.pdf.table.labelCsv.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      this.csv.label = column
      let csvData = {}
      let pdfData = {
        id: data.ID,
        status: data.reservationState === 'NOSHOW' ? data.reservationState : 'COMPLETED',
        pickupTime: moment(data.pickupTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY HH:mm'),
        completedTime: moment(data.completedTime, 'YYYY-MM-DD@HH:mm').format('MM/DD/YYYY HH:mm'),
        fare: this.covertNumber(parseFloat(data.fareAmount || 0).toFixed(2)),
        source: data.deviceType === 'ww' ? 'web' : data.deviceType,
        guestName: `${data.guestFname || ''} ${data.guestLname || ''}`,
        guestPhone: data.guestPhone,
        consumerNotes: data.consumerNotes || ''
      }

      let i = 0
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key]
        i++
      }
      return csvData
    },
    processDownloads (action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page)
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type)
      } else {
        this.generateReport()
      }
    },
    processCsv (type) {
      const exporter = CsvExport.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      })

      // add total
      let completed = []
      let noshow = []
      this.csv.data.forEach(dat => {
        if (dat.Status === 'COMPLETED') {
          completed.push(dat)
        } else {
          noshow.push(dat)
        }
      })
      this.csv.data = [...completed, ...noshow]

      exporter.downloadCsv(this.csv.data)
      this.reportStatus[type] = 'success'
      this.csv.list.shift()

      this.generateReport(true)
    },
    buildCsvTotal (type) {
      let csvData = {}
      let totalData = this.pdf.table.total

      if (type === 'directBill') {
        // csvData[this.csv.label[0]] = 'Total (' + (totalData.totalCompleted + totalData.totalNoShow) + ')'
        csvData[this.csv.label[0]] = ''
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        // csvData[this.csv.label[4]] = '$' + (parseFloat(totalData.fareCompleted.replace(/,/g,'')) + parseFloat(totalData.fareNoShow)).toFixed(2)
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
      }

      if (type === 'payout') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = totalData.drivers
        csvData[this.csv.label[2]] = totalData.rsvp
        csvData[this.csv.label[3]] = totalData.pax
        csvData[this.csv.label[4]] = totalData.avgPax
        csvData[this.csv.label[5]] = totalData.fare
        csvData[this.csv.label[6]] = totalData.travelInsurance
        csvData[this.csv.label[7]] = totalData.airportFee
        csvData[this.csv.label[8]] = totalData.fareSum
        csvData[this.csv.label[9]] = totalData.avgFare
        csvData[this.csv.label[10]] = totalData.payment
        csvData[this.csv.label[11]] = totalData.paymentPercent
        csvData[this.csv.label[12]] = totalData.pickupFee
        csvData[this.csv.label[13]] = totalData.tips
        csvData[this.csv.label[14]] = totalData.bonus
        csvData[this.csv.label[15]] = totalData.cancelFee
        csvData[this.csv.label[16]] = totalData.extraFee
        csvData[this.csv.label[17]] = totalData.percent
      }

      if (type === 'cancellationReport') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = totalData.fare
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
        csvData[this.csv.label[7]] = ''
        csvData[this.csv.label[8]] = ''
      }

      if (type === 'driverPaymentBonus') {
        csvData[this.csv.label[0]] = 'Total (' + totalData.record + ')'
        csvData[this.csv.label[1]] = ''
        csvData[this.csv.label[2]] = ''
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = totalData.baseFare
        csvData[this.csv.label[5]] = totalData.driverPayment
        csvData[this.csv.label[6]] = totalData.bonus
        csvData[this.csv.label[7]] = totalData.avgBonus
        csvData[this.csv.label[8]] = totalData.totalDriverPayment
        csvData[this.csv.label[9]] = ''
        csvData[this.csv.label[10]] = ''
      }

      return csvData
    },
    formatCheck () {
      this.error.show = false
      this.formatError = false
    },
    selectAdmin (admin) {
      this.searchAdmin = admin.name
      this.searchAdminId = admin.id
      this.showSearchAdminList = false
    },
    adminSearchFocus () {
      this.showSearchAdminList = true
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay)
      }
    },
    adminSearchBlur () {
      if (this.searchAdminDelay) {
        clearTimeout(this.searchAdminDelay)
      }
      this.searchAdminDelay = setTimeout(() => {
        this.showSearchAdminList = false
      }, 500)
    },
    getCorporates () {
      let self = this
      self.corpLoading = true
      self.$sdk.get('/admin/corporateprofile', {
        token: self.$store.state.session.sessionToken,
        pageNum: 1,
        pageSize: 999
      }, r => {
        self.corpLoading = false
        r.list.forEach(corp => {
          if (corp.active == 1) {
            self.dbUsers.push({
              id: corp.custContactID,
              name: corp.name
            })
          }
        })

        if (self.dbUsers.length) {
          self.dbUsers.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
            if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
            return 0
          })
        }
      })
    }
  },
  watch: {
    show (value) {
      if (!value) { return }

      this.from = null
      this.to = null
      this.error.show = false
      this.error.empty = []

      this.resetSelectedStatus()
      this.resetReportStatus()
    },
    from (value) { this.resetReportStatus() },
    to (value) { this.resetReportStatus() },
    'selectedReports.directBill' (value) { this.resetReportStatus() },
    'selectedReports.payout' (value) { this.resetReportStatus() },
    'selectedReports.serviceTypeBrand' (value) { this.resetReportStatus() },
    'selectedReports.cancellationReport' (value) { this.resetReportStatus() },
    'selectedReports.driverPaymentBonus' (value) { this.resetReportStatus() }
  },
  mounted () {
    let self = this
    setTimeout(()=> {
      self.getCorporates()
    }, 1500)
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }

  & .date-input {
    margin-bottom: 10px;

    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
    select{
      padding: 10px;
      height: 46px;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-color: #cacaca;
      font-size: 14px;
      color: #333;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;

      &[disabled]{ background-color: #ebebe4; }
    }
  }

  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    overflow: auto;
    clear: both;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;

    .report{
      position: relative;
      z-index: 1;

      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;

        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}

.filter{
  list-style: none;
  margin: 0 0 5px;
  padding: 0;
  font-size: 13px;
  display: flex;

  li{
    margin: 2px 0;
    width: 100%;
  }
  label{ cursor: pointer;}
  input{
    display: inline-block;
    margin: 0 3px 0 0;
    width: auto;
    vertical-align: middle;
  }
}

.download-type{
  // float: right;
  width: 100%;
  text-align: right;
  padding-bottom: 5px;

  label{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 7px;
    border:1px solid #ddd;

    &.pdf{ color: #c54d4d; }
    &.csv{ color: #7ad275; }
    &.has-error{ border: 1px solid #d00; }
    input{
      display: inline;
      margin-top: 0;
      width: auto;
      vertical-align: -1px;
    }
  }
}

.list-box{
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}

.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;

  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;

    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}

.form-group {
  display: block;

  & .instruction {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
}

.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }

#pdf-view{
  position: absolute;
  top: 100%;
  left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;

  .page{
    padding: 30px 40px 30px 30px;
    position: relative;
    width: 100%;
    height: 100%;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }

  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 12px;
        }
      }
      td{ padding: 2px 3px; }
    }
  }
}

.report-direct-bill{
  width: 1122px!important;
  height: 793px!important;
  table tbody{
    td{ text-align: center; }
    .fare{ text-align: right; }
    .pickupTime, .completedTime{ width: 120px; }
    .consumerNotes{
      font-size: 11px;
      line-height: 1.15;
    }
  }
}

.report-payout{
  width: 1122px!important;
  height: 793px!important;
  table{
    tbody tr.total{
      border-top: 1px solid #333;
      font-weight: 600;
      font-size:12.5px
    }
    .driverCount, .rsvpCount, .totalPax, .avgPax{ text-align: center; }
    .fare, .totalFare, .avgFare, .travelInsurance, .airportFee, .extraFee, .charged, .payment, .pickupFee,
    .tips, .bonus, .cancelFee, .driverPayment, .paymentPercent, .driverPercent{ text-align: right; }
    .driverPayment{ font-weight: 600; }
    .fare, .travelInsurance, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }
    .company{
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.service-brand{
  width: 1122px!important;
  height: 793px!important;

  .brand-box{ margin-bottom: 50px; }
  table{
    tbody tr.total{
      border-top: 1px solid #333;
      font-weight: 600;
    }
    .rsvp, .asap, .web, .admin, .app, .go, .paxSum, .paxAvg{ text-align: center; }
    .fareSum, .fareAvg, .farePP{ text-align: right; }
    /*.fare, .airportFee, .payment, .pickupFee, .tips, .bonus, .cancelFee{ color: #777; }*/
  }
}

.driver-payment-bonus{
  width: 1122px!important;
  height: 793px!important;

  table{
    .rsvpId, .brand, .updatedOn, .baseFare, .driverPayment, .bonus, .avgBonus, .totalDriverPayment{ text-align: center; }
    // .baseFare, .driverPayment, .bonus, .avgBonus, .totalDriverPayment{ color: #777; }
    .driverName, .updatedBy{
      width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.admin-box {
  position: relative;
  margin: 0 15px 15px 28px;

  input{
    padding: 5px 8px;
    margin: 0 0 5px;
    font-size: 14px;
  }
  ul{
    padding: 0;
    margin: 0;
    list-style: none;
    background: #fafafa;
    border: 1px solid #ccc;
    border-radius: 2px;
    height: 100px;
    overflow: auto;
    li{
      display: block;
      line-height: 1;
      padding: 5px 8px;
      font-size: 14px;
      color: #333;

      &:hover{
        background: #f3f3f3;
      }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .end-date {
    /deep/ .vdp-datepicker__calendar {
      right: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/DirectBill.vue